//      
                                                      
                                                         

export default class BaseStorage                                 {
	key        ;
	storage             ;

	constructor(dealerId        , keySuffix        , storage              = window.localStorage) {
		this.key = dealerId + keySuffix;
		this.storage = storage;
	}

	get()      {
		return this.storage.getItem(this.key);
	}

	set(value        )       {
		return this.storage.setItem(this.key, value);
	}

	clear()       {
		return this.storage.removeItem(this.key);
	}
};
